import dotProp from 'dot-prop-immutable';
import isEmpty from 'lodash/isEmpty';

import * as actionTypes from './actiontypes';
import states from './states';

export default function intent_details(state = states.intent_details, action) {
    switch (action.type) {
        case actionTypes.UPDATE_INTENT_STATE: {
            return dotProp.set(state, action.path, action.payload);
        }

        case actionTypes.DELETE_INTENT_STATE: {
            return dotProp.delete(state, action.path);
        }

        case actionTypes.ALL_INTENTS_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    intents_loading: true,
                    intents_loaded: false,
                }
            };
        }

        case actionTypes.ALL_INTENTS_LOADED: {
            return {
                ...state,
                intents: action.payload && action.payload.intents ? action.payload.intents : [...state.intents],
                loaders: {
                    ...state.loaders,
                    intents_loading: false,
                    intents_loaded: true,
                }
            };
        }

        case actionTypes.ALL_INTENTS_LOAD_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    intents_loading: false,
                    intents_loaded: false,
                }
            };
        }

        case actionTypes.INTENT_CREATING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    intent_creating: true,
                }
            };
        }

        case actionTypes.INTENT_CREATED: {
            return {
                ...state,
                intents: action.payload.intent ? [action.payload.intent, ...state.intents] : [...state.intents],
                loaders: {
                    ...state.loaders,
                    intent_creating: false,
                }
            };
        }

        case actionTypes.INTENT_CREATION_FAILED: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    intent_creating: false,
                }
            };
        }

        case actionTypes.INTENT_DELETED: {
            let index = -1;
            if (action.payload && action.payload.intentUniqueId) {
                index = state.intents.findIndex((intent) => { return (intent.intentUniqueId === action.payload.intentUniqueId) });
            }
            return {
                ...state,
                intents: index === -1 ? [...state.intents] : [...state.intents.slice(0, index), ...state.intents.slice(index + 1)],
            };
        }

        case actionTypes.INTENT_DATA_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    intent_data_loading: true,
                    intent_data_loaded: false,
                }
            };
        }

        case actionTypes.INTENT_DATA_LOADED: {
            return {
                ...state,
                active_intent_data: action.payload && action.payload.intent ? action.payload.intent : { ...state.active_intent_data },
                loaders: {
                    ...state.loaders,
                    intent_data_loading: false,
                    intent_data_loaded: true,
                }
            };
        }

        case actionTypes.INTENT_DATA_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    intent_data_loading: false,
                    intent_data_loaded: false,
                }
            };
        }

        case actionTypes.NEW_UTTERANCE_ADDED: {
            let active_intent_data = { ...state.active_intent_data };
            if (action.payload && action.payload.intentUniqueId && action.payload.utterance && !isEmpty(active_intent_data) && active_intent_data.intentUniqueId === action.payload.intentUniqueId) {
                let index = -1;
                index = active_intent_data.utterances.findIndex(utterance => utterance.text === action.payload.utterance.text);
                active_intent_data = {
                    ...active_intent_data,
                    utterances: index === -1 ? [action.payload.utterance, ...active_intent_data.utterances] : [...active_intent_data.utterances.slice(0, index), action.payload.utterance, ...active_intent_data.utterances.slice(index + 1)],
                }
            }
            return {
                ...state,
                active_intent_data,
            };
        }

        case actionTypes.UTTERANCE_DELETED: {
            let active_intent_data = { ...state.active_intent_data };
            if (action.payload && action.payload.intentUniqueId && action.payload.id && !isEmpty(active_intent_data) && active_intent_data.intentUniqueId === action.payload.intentUniqueId) {
                const index = active_intent_data.utterances.findIndex((utterance) => { return (utterance.id === action.payload.id); });
                if (index !== -1) {
                    active_intent_data = {
                        ...active_intent_data,
                        utterances: [...active_intent_data.utterances.slice(0, index), ...active_intent_data.utterances.slice(index + 1)],
                    }
                }
            }
            return {
                ...state,
                active_intent_data,
            };
        }

        case actionTypes.UTTERANCE_UPDATED: {
            let active_intent_data = { ...state.active_intent_data };
            if (action.payload && action.payload.intentUniqueId && action.payload.removedUtteranceId && action.payload.utterance && !isEmpty(active_intent_data) && active_intent_data.intentUniqueId === action.payload.intentUniqueId) {
                let index = -1;
                index = active_intent_data.utterances.findIndex((utterance) => { return (utterance.id === action.payload.removedUtteranceId); });
                if (index !== -1) {
                    active_intent_data = {
                        ...active_intent_data,
                        utterances: [...active_intent_data.utterances.slice(0, index), action.payload.utterance, ...active_intent_data.utterances.slice(index + 1)],
                    }
                }
            }
            return {
                ...state,
                active_intent_data,
            };
        }

        case actionTypes.INTENT_UPDATED: {
            let index = -1;
            if (action.payload && action.payload.intent && action.payload.intent.intentUniqueId) {
                index = state.intents.findIndex((intent) => { return (intent.intentUniqueId === action.payload.intent.intentUniqueId) });
            }
            return {
                ...state,
                intents: index === -1 ? [...state.intents] : [...state.intents.slice(0, index), action.payload.intent, ...state.intents.slice(index + 1)],
            };
        }

        case actionTypes.CLEAR_ACTIVE_INTENT: {
            return {
                ...state,
                active_intent_data: {},
            };
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/data/redux/intent_details/reducers.js